module.exports = __webpack_public_path__ + "static/img/区域市场主体概览.f250dd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/区域市场主体概览.jpg
// module id = f2ek
// module chunks = 1